/**
 * Colorado reference constants (spec Part 20).
 * Purchase-limit *dates* use America/Denver in server code — not encoded here.
 */
export const COLORADO_PURCHASE_LIMITS = {
    FLOWER_MAX_OZ: 1.0,
    CONCENTRATE_MAX_G: 8.0,
    THC_MAX_MG: 800.0,
    VEHICLE_MAX_LOAD_CENTS: 1_000_000,
    CO_DELIVERY_SURCHARGE_CENTS: 100,
};
/** One “unit” = up to 1 oz flower, or 8 g concentrate, or 800 mg THC — not three independent daily maxima. */
export const COLORADO_DAILY_PURCHASE_MAX_OUNCE_EQUIVALENT = 1.0;
/**
 * Colorado recreational daily purchase pool (1 CCR 212-3 retail): one combined **ounce-equivalent**
 * budget per calendar day. Flower counts in oz; concentrate in grams (÷8); infused THC in mg (÷800).
 */
export function coloradoPurchaseOunceEquivalent(d) {
    const f = Number.isFinite(d.flowerOz) ? d.flowerOz : 0;
    const c = Number.isFinite(d.concentrateG) ? d.concentrateG : 0;
    const t = Number.isFinite(d.thcMg) ? d.thcMg : 0;
    return (f + c / COLORADO_PURCHASE_LIMITS.CONCENTRATE_MAX_G + t / COLORADO_PURCHASE_LIMITS.THC_MAX_MG);
}
export const COLORADO_TAX_RATES = {
    STATE_SALES_TAX: 0.029,
    RETAIL_MARIJUANA_SPECIAL: 0.15,
    EXCISE_TAX: 0.15,
};
export const COLORADO_TIMEZONE = "America/Denver";
export const COLORADO = {
    PURCHASE_LIMITS: COLORADO_PURCHASE_LIMITS,
    TAX_RATES: COLORADO_TAX_RATES,
    TIMEZONE: COLORADO_TIMEZONE,
    MIN_CUSTOMER_AGE: 21,
};
//# sourceMappingURL=colorado.js.map